import { HistoricoSection } from '../HistoricoSection'
import { HistoricoItemCard } from '../HistoricoItemCard'
import { useHistoricoPaciente } from '../../hooks/useHistoricoPaciente'
import { downloadPrescription } from '../../../prescricao/core/_requests'
import { downloadArquivo, showError } from '../../../../../../../_metronic/helpers'

type Props = {
  /** Vem por prop (e não `useParams`): a seção é aberta num modal, que fica fora das rotas. */
  pacienteId: number
}

export const PrescricoesSection = ({ pacienteId }: Props) => {
  const { fetchPrescricoes } = useHistoricoPaciente(String(pacienteId))

  const handleDownload = async (id: number) => {
    try {
      const arquivo = await downloadPrescription(id)
      downloadArquivo(arquivo)
    } catch (error) {
      showError(error)
    }
  }

  return (
    <HistoricoSection
      title='Prescrições'
      fetcher={fetchPrescricoes}
      renderItem={(item) => (
        <HistoricoItemCard
          key={item.id}
          title={
            item.descricao === 'Atestado'
              ? 'Atestado de Saúde'
              : item.descricao === 'Orientações'
              ? 'Orientações Médicas'
              : `Prescrição de ${item.descricao}`
          }
          subtitle={item.dataFormatada}
          onClick={() => handleDownload(item.id)}
        />
      )}
    />
  )
}
